import SuccessCard from './success-card';

export default SuccessCard;
